import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { IndustryBuilderGuard } from "@/components/auth/IndustryBuilderGuard";
import EventProposalBuilder from "@/pages/EventProposalBuilder";
export const Route = createFileRoute("/event-builder")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><IndustryBuilderGuard industry="event-staffing"><EventProposalBuilder /></IndustryBuilderGuard></ProtectedRoute>) });
